// extracted by mini-css-extract-plugin
export default {"container":"ParticipantOverview_container__GKpk6","overviewTable":"ParticipantOverview_overviewTable__HJY4G"};